import { z } from "zod";
import { siteCodeSchema } from "./validation.js";
export const TARGET_SCOPES = ["site", "site_group", "global"];
export const contentTargetingBaseSchema = z.object({
    targetScope: z.enum(TARGET_SCOPES).optional(),
    siteCode: siteCodeSchema.optional(),
    groupId: z.string().min(1).max(64).optional(),
    priority: z.number().int().min(0).max(1000).optional(),
});
export const contentTargetingFieldsSchema = contentTargetingBaseSchema.superRefine((data, ctx) => {
    const scope = resolveTargetScope(data);
    if (!scope) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "targetScope, siteCode, or groupId required",
        });
        return;
    }
    if (scope === "site" && !data.siteCode) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "siteCode required for site targeting",
            path: ["siteCode"],
        });
    }
    if (scope === "site_group" && !data.groupId) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "groupId required for group targeting",
            path: ["groupId"],
        });
    }
    if (scope === "global" && (data.siteCode || data.groupId)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Global targeting must not include site or group",
        });
    }
});
/** Infer scope from explicit field or legacy siteCode-only payloads. */
export function resolveTargetScope(input) {
    if (input.targetScope)
        return input.targetScope;
    if (input.groupId)
        return "site_group";
    if (input.siteCode)
        return "site";
    return null;
}
export function targetScopeToContentScope(scope) {
    return scope;
}
export const TARGET_SCOPE_LABELS = {
    site: "سایت",
    site_group: "گروه سایت",
    global: "سراسری",
};
//# sourceMappingURL=content-targeting.js.map